// The remembered active role on the web (FR-031, FR-032; data-model §6). Unknown or unreadable values
// are ignored. Android never writes it (PARENT always wins there, FR-029).
import { Platform } from "react-native";

import { deviceStorage } from "@/lib/deviceStorage";

import type { ServedRole } from "./types";

const KEY = "akaiva.activeRole";

export const activeRolePreference = {
  async read(): Promise<ServedRole | null> {
    const value = await deviceStorage.get(KEY);
    return value === "PARENT" || value === "SCHOOL_ADMIN" ? value : null;
  },
  async write(role: ServedRole): Promise<void> {
    if (Platform.OS === "web") await deviceStorage.set(KEY, role);
  },
  async clear(): Promise<void> {
    await deviceStorage.remove(KEY);
  },
};
